import Head from 'next/head';
import React from 'react';
import { getCurrentOrganization, getOrganizationPropertiesByHost } from '../utils/helpers';
import { useMiscellaneousData } from '../contexts/ssr-miscellaneous-context';

function MetaHead({
  // eslint-disable-next-line react/prop-types
  title, description, keywords, author,
}) {
  let domainName;
  const { miscellaneousData } = useMiscellaneousData();
  if (miscellaneousData?.hostname) {
    domainName = getOrganizationPropertiesByHost(miscellaneousData.hostname);
  } else {
    domainName = getCurrentOrganization();
  }

  let titleDomainName;

  // console.log('hhhahah', domainName.organizationName);

  if (domainName.organizationName === 'nextias') {
    titleDomainName = 'NextIas.com';
  } else if (domainName.organizationName === 'madeeasyprime') {
    titleDomainName = 'Madeeasyprime.com';
  } else {
    titleDomainName = 'Meniit.com';
  }
  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <Head>
      <title>{title || titleDomainName}</title>
      <meta name="description" content={description || titleDomainName} />
      <meta name="keywords" content={keywords || titleDomainName} />
      <meta name="author" content={author || titleDomainName} />
    </Head>
  );
}

export default React.memo(MetaHead);
